import { Tooltip } from "@material-ui/core";
import { SwapHoriz } from "@material-ui/icons";
import React from "react";
import { UseFormMethods, useWatch } from "react-hook-form";

export type FormStateIndicatorProps = {
  control: UseFormMethods["control"];
  errors: UseFormMethods["errors"];
  formState: UseFormMethods["formState"];
  whiteList?: string[];
  blackList?: string[];
};

export const FormStateIndicator: React.FC<FormStateIndicatorProps> = ({
  errors,
  control,
  formState,
  whiteList,
  blackList,
}) => {
  // using useWatch to rerender this control every time anything is touched on the form
  useWatch({ control });

  const errorCount = recurseCountKeys(filterKeys(errors, whiteList, blackList));
  const dirtyCount = recurseCountKeys(
    filterKeys(formState.dirtyFields, whiteList, blackList)
  );

  return errorCount || dirtyCount ? (
    <Tooltip title="There are unsaved changes in this section">
      <SwapHoriz />
    </Tooltip>
  ) : (
    <>&nbsp;&nbsp;</>
  );
};

const filterKeys = (
  object: { [key: string]: any },
  whiteList: string[] | undefined,
  blackList: string[] | undefined
) => {
  return Object.keys(object).reduce((acc, key) => {
    const isOkWhitelist = whiteList === undefined || whiteList.includes(key);
    const isOkBlacklist = blackList === undefined || !blackList.includes(key);

    return isOkWhitelist && isOkBlacklist
      ? { ...acc, [key]: object[key] }
      : acc;
  }, {} as { [key: string]: any });
};

const recurseCountKeys = (
  object: { [key: string]: any } | { [key: string]: any }[]
) => {
  let count = 0;

  if (Array.isArray(object)) {
    object.forEach((item) => {
      count += recurseCountKeys(item);
    });
  } else {
    Object.keys(object).forEach((key) => {
      if (Array.isArray(object[key])) {
        count += recurseCountKeys(object[key]);
      } else {
        count += 1;
      }
    });
  }

  return count;
};
